<!-- 获取单个停车场空车位接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {

               // "userId":""
               parkCode:"2KPGDYCO"
            },
            responseCode: {
                "data": {
                "menuList":[ {
                "hasChecked": 0,
                "id": "10",
                "name": "停车场管理",
                "parentId": "00"
            },
            {
                "hasChecked": 0,
                "id": "101",
                "name": "车场配置",
                "parentId": "10"
            }],
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取VEMS系统菜单树信息",
                t_url: this.commonUrls.test+"getMenuData",
                p_url: this.commonUrls.prod+"getMenuData",
                precondition: "VEMS 2.16及以上版本",
                fitSystem: "VEMS传统停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                       // { info1: 'userId', info2: '否', info3: 'String', info4: '系统管理员Id,如果填写,则获取该系统管理员的权限树,否则获取整个权限树' }
                       { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'menuList', info2: '是', info3: 'JSONArray', info4: '菜单列表' }
                        ]
                },{
                    titleName: "menuList",
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'id', info2: '是', info3: 'String ', info4: '菜单项id' },
                        { info1: 'name', info2: '是', info3: 'String', info4: '菜单名称' },
                        { info1: 'parentId', info2: '是', info3: 'String', info4: '父id,‘00’为根节点' },
                        { info1: 'hasChecked', info2: '是', info3: 'Integer', info4: '是否有被启用,0:没有启用,1:有启用' },


                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/yard/getMenuData.vue